export const replaceWhitespaceCharacters = string =>
  string.replace(/\s+/g, ' ');
